module.exports = __webpack_public_path__ + "img/logo_ma_orange.c0d8ac1c.svg";